/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import React from 'react';
import { replaceImageServer, usePlaceholderImage } from '../../helpers/image';

const ImageComponent = ({ deal, height, priority, width }) => {
  return (
    <img
      alt={deal?.image?.alt || deal?.images[0].alt}
      fetchpriority={priority ? 'high' : 'low'}
      height={height}
      loading={priority ? 'eager' : 'lazy'}
      onError={usePlaceholderImage}
      src={replaceImageServer({
        dealId: deal.id,
        height,
        image: deal?.image || deal.images[0],
        isSubSubCat: true,
        width,
      })}
      width={width}
    />
  );
};

ImageComponent.propTypes = {
  deal: PropTypes.object,
  height: PropTypes.number,
  priority: PropTypes.bool,
  width: PropTypes.number,
};

export default ImageComponent;
